import { shadingLightestColor } from "Common/componentUtils/modalUtils";
import { themeVariables } from "Components/theme";
import WithModal from "Components/withModal";
import React, { useEffect, useState } from "react";
import TasksLogsInner from "./tasksLogs.inner";
const SIZES = {
    MODAL_DEFAULT_WIDTH: 800,
    MODAL_DEFAULT_HEIGHT: 600,
    PREVIEW_MIN_WIDTH: 100
};
export default function TasksLogs(props) {
    const [isOpen, setIsOpen] = useState(false);
    const [tasksLogs, setTasksLogs] = useState([]);
    const onHide = () => {
        var _a;
        setIsOpen(false);
        (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
    };
    useEffect(() => {
        setIsOpen(props.isOpen || false);
    }, [props.isOpen]);
    useEffect(() => {
        props.subTasksIds && props.isOpen && props.getTasksLogs(props.subTasksIds, setTasksLogs);
    }, [props.subTasksIds, props.isOpen]);
    return (React.createElement(WithModal, { showTitle: false, closeBtn: true, hideOnOutsideClick: true, show: isOpen, onHide: onHide, shadingColor: shadingLightestColor, className: "bg-blur", defaultWidth: SIZES.MODAL_DEFAULT_WIDTH, defaultHeight: SIZES.MODAL_DEFAULT_HEIGHT, isLoading: props.inProgress },
        React.createElement(TasksLogsInner, { data: tasksLogs, onClose: props.onClose, title: props.title, zIndex: parseInt(themeVariables["zindex-pageheader-menu"]) + 6 })));
}
